var _path, _path2, _g, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9994 42.9997C85.9994 66.749 66.749 85.9994 42.9997 85.9994C19.2531 85.9994 0 66.749 0 42.9997C0 19.2531 19.2531 0 42.9997 0C66.749 0 85.9994 19.2531 85.9994 42.9997Z",
    fill: "#2C3842"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2101_2287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 86,
    height: 86
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9999 42.9996C85.9999 54.4038 81.4696 65.3409 73.4056 73.4049C65.3416 81.4689 54.4045 85.9992 43.0003 85.9992C31.5961 85.9992 20.659 81.4689 12.595 73.4049C4.53102 65.3409 0.000732422 54.4038 0.000732422 42.9996C0.000732422 31.5954 4.53102 20.6583 12.595 12.5943C20.659 4.53029 31.5961 0 43.0003 0C54.4045 0 65.3416 4.53029 73.4056 12.5943C81.4696 20.6583 85.9999 31.5954 85.9999 42.9996Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2101_2287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8543 59.4282C34.3864 59.3288 25.2329 63.0967 12.3276 70.1325C9.82824 71.4978 8.98975 74.1019 8.98975 76.9506V86.5504H77.0099V75.8382C77.0099 73.2851 74.6503 70.9494 72.4197 69.7159C62.7824 64.3839 50.8607 59.1836 51.0354 59.1487L33.8543 59.4282Z",
    fill: "#B5BDC4"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3094 61.3768C51.3094 63.7367 50.372 66 48.7032 67.6688C47.0345 69.3375 44.7712 70.275 42.4112 70.275C40.0512 70.275 37.7879 69.3375 36.1192 67.6688C34.4504 66 33.5129 63.7367 33.5129 61.3768C33.5129 59.0168 34.4504 56.7535 36.1192 55.0848C37.7879 53.416 40.0512 52.4785 42.4112 52.4785C44.7712 52.4785 47.0345 53.416 48.7032 55.0848C50.372 56.7535 51.3094 59.0168 51.3094 61.3768Z",
    fill: "#FFCCAA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.793 8.73145C49.3367 8.73145 57.7109 15.6463 57.2729 24.2087L56.2973 43.1447C55.8566 51.707 47.1814 63.1529 41.793 63.1529C36.4046 63.1529 27.7294 51.707 27.2886 43.1447L26.3157 24.2087C25.875 15.6463 34.2519 8.72876 41.7956 8.72876L41.793 8.73145Z",
    fill: "#FFCCAA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3443 39.845C60.3846 43.4059 58.6324 46.3111 56.4313 46.3352C54.233 46.3621 52.4162 43.4946 52.3759 39.9337C52.3356 36.3754 54.0879 33.4676 56.2889 33.4434C58.49 33.4192 60.304 36.2867 60.3443 39.845ZM31.5184 39.845C31.5587 43.4059 29.8065 46.3111 27.6054 46.3352C25.4071 46.3621 23.5903 43.4946 23.55 39.9337C23.5097 36.3754 25.2619 33.4676 27.463 33.4434C29.664 33.4192 31.4781 36.2867 31.5184 39.845Z",
    fill: "#FFCCAA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3751 41.4437C63.4029 32.9728 63.7657 20.4061 55.2947 13.3784C48.6083 7.83141 38.0841 5.65455 32.7387 11.6476C31.0805 13.5101 28.7451 14.4802 27.2293 15.9879C21.0428 22.1369 22.3543 32.2552 27.103 39.5706V30.8363C27.103 27.2431 31.876 25.6897 36.6355 25.6897H45.5392C51.0592 25.6897 56.703 29.3313 56.531 35.706L56.3751 41.4437Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/defaultImage.4adbc84f22e7e3c173b3b9f01e4dd2bc.svg";
export { ForwardRef as ReactComponent };